// G500Lite
export const g500LiteBaseURL = 'https://drweb-stg.obvious.jp/safetyDriverSupport';

// Offseg
export const offsegBaseURL = 'https://www.dev.offseg.obvious.jp/offseg-admin/index.html#';